/**
 * SITE_FACING: sites
 */
export default {
  "eproViewer.surveyComplete": "Survey Complete",
  "eproViewer.ellipsis": "...",
  "eproViewer.answerImageFallback": "Answer {number}",
  "eproViewer.back": "Back",
  "eproViewer.blockHeadingAriaLabel": "Block Heading",
  "eproViewer.calendarInputTitle": "Open Calendar",
  "eproViewer.cancel": "Cancel",
  "eproViewer.confirm": "Confirm",
  "eproViewer.close": "Close",
  "eproViewer.remove": "Remove",
  "eproViewer.cantDisplayModalHeader": "Can't display survey",
  "eproViewer.cantDisplayModalMessage":
    "We can't currently display the survey on your device. Please try rotating your device, zooming out, or using another device.",
  "eproViewer.date": "Date",
  "eproViewer.dateError": "Please enter a date between {min} and {max}.",
  "eproViewer.dateQuestionLabel": "Item {itemNumber}: Date question",
  "eproViewer.dateTimeError":
    "Please enter a date and time between {min} and {max}.",
  "eproViewer.dateTimeQuestionLabel": "Item {itemNumber}: Datetime question",
  "eproViewer.headingImageFallback": "Question{questionNumber}",
  "eproViewer.headingImageTextBlockFallback": "Instructions",
  "eproViewer.licenseImageFallback": "Survey License",
  "eproViewer.loadingSurvey": "Loading Survey...",
  "eproViewer.loggedOut": "Logged out",
  "eproViewer.loggedOut2": "Logged Out",
  "eproViewer.loggedOutWhileInactive":
    "We logged you out while you were inactive. Please select OK to log in again.",
  "eproViewer.linkBlock.completedToday": "Completed today at {time}",
  "eproViewer.linkBlock.completedYesterday": "Completed yesterday at {time}",
  "eproViewer.linkBlock.completedDate": "Completed {date} at {time}",
  "eproViewer.linkBlock.lastUpdatedAt": "Last updated at {time}",
  "eproViewer.multipleChoiceQuestionLabel":
    "Item {itemNumber}: Multiple-choice question",
  "eproViewer.next": "Next",
  "eproViewer.numberEntryIncrementError":
    "Please enter a value that's a multiple of {increment}.",
  "eproViewer.numberEntryMultiFieldsIncrementError":
    "<b>{label}:</b> Please enter a value that's a multiple of {increment}.",
  "eproViewer.numberEntryQuestionLabel":
    "Item {itemNumber}: Number Entry question",
  "eproViewer.numberEntryRangeError":
    "Please enter a value between {minNumber} and {maxNumber}.",
  "eproViewer.numberEntryMultiFieldsRangeError":
    "<b>{label}:</b> Please enter a value between {minNumber} and {maxNumber}.",
  "eproViewer.numberOfNumber": "{lowerNumber} of {greaterNumber}",
  "eproViewer.numericScaleImageFallback": "Number Scale",
  "eproViewer.numericScaleQuestionLabel":
    "Item {itemNumber}: Numeric Scale question",
  "eproViewer.tapToRefresh": "Tap to refresh list",
  "eproViewer.lastUpdatedError": "Update error. Try again. {dateTime}",
  "eproViewer.emptyStateDefault":
    "There are no surveys that you can select. Complete the survey and try again.",
  "eproViewer.tapToViewMore": "Tap to view more",
  "eproViewer.tryRotatingYourScreenTitle": "Try Rotating your Device",
  "eproViewer.tryRotatingYourScreenDescription":
    "For a better experience, try rotating your device or viewing on a wider screen.",
  "eproViewer.ok": "OK",
  "eproViewer.percentComplete":
    "{progressPercentage}<br></br><size>complete</size>",
  "eproViewer.training": "Training",
  "eproViewer.training.percentComplete":
    "{progressPercentage}<br></br><size>training complete</size>",
  "eproViewer.pleaseProvideAResponse": "Please provide a response.",
  "eproViewer.pleaseReconnectToContinue": "Please reconnect to continue.",
  "eproViewer.previous": "Previous",
  "eproViewer.previewSummaryBlocksResponse": "Preview summaryBlocks Response",
  "eproViewer.previewSummarySurveyDisplayName":
    "Preview Related Survey Display Name",
  "eproViewer.questionNotApplicable":
    "Question {questionNumber} not applicable",
  "eproViewer.questionsNotApplicable":
    "Questions {firstQuestionNumber}-{lastQuestionNumber} not applicable",
  "eproViewer.restrictedDataSurveyWarning":
    "This survey contains restricted data",
  "eproViewer.scoringResultsError": "Error calculating results",
  "eproViewer.scoringResultsErrorRow": "Error calculating result",
  "eproViewer.scoringResultsHeader": "Results",
  "eproViewer.selectAllThatApply": "Select all that apply",
  "eproViewer.selectOne": "Select one",
  "eproViewer.singleChoiceQuestionLabel":
    "Item {itemNumber}: Single-choice question",
  "eproViewer.linkQuestionLabel": "Item {itemNumber}: Link question",
  "eproViewer.start": "Start",
  "eproViewer.startSurvey": "Start Survey",
  "eproViewer.startSurveyDescription":
    "Once you start this survey, you are the only person who can complete and submit it.",
  "eproViewer.done": "Done",
  "eproViewer.submit": "Submit",
  "eproViewer.submitting": "Submitting",
  "eproViewer.reviewBeforeSubmit":
    "You can review and make changes by scrolling up. When you are ready, submit your answers.",
  "eproViewer.surveyStartErrorMessage":
    "Another survey must be completed before starting this survey. To start the other survey, select <b>Start.</b>",
  "eproViewer.surveyStartErrorTitle": "Survey Couldn't Be Started",
  "eproViewer.siteMediaCantViewPdfPreview":
    "Cannot preview {pdf}. Click the view {pdf} icon to open.",
  "eproViewer.siteMediaDocument": "document",
  "eproViewer.siteMediaQuestionLabel": "Item {itemNumber}: Site Media question",
  "eproViewer.siteMediaAlt": "siteMedia-response-image",
  "eproViewer.siteMediaQuestionBanner":
    "Make sure you do not include identifying information in the file.",
  "eproViewer.siteMediaContentTooLargeError":
    "PDFs cannot have more than 50 pages.",
  "eproViewer.siteMediaFileFormatAndSizeError":
    "The file was too large or in the wrong format. No file was added. Resize or reformat the file and try again.",
  "eproViewer.siteMediaUploadMultipleFilesError":
    "Multiple files cannot be uploaded. Upload one file and try again.",
  "eproViewer.siteMediaAcceptedMediaTypes": "{jpg}, {png}, or {pdf}",
  "eproViewer.siteMediaDragAndDropFile": "Drag and drop a file",
  "eproViewer.siteMediaOr": "or",
  "eproViewer.siteMediaUploadFile": "Upload File",
  "eproViewer.siteMediaAcceptedFileFormats": "File Formats Accepted: ",
  "eproViewer.siteMediaMaxFileSize": "Max File Size:",
  "eproViewer.siteMediaMB": "{number} MB",
  "eproViewer.siteMediaDeleteMedia": "Delete Media",
  "eproViewer.siteMediaRemoveFileMessage":
    "Do you want to permanently remove this file?",
  "eproViewer.siteMediaRemoveFile": "Remove File",
  "eproViewer.siteMediaPreviewHeader": "Media Upload",
  "eproViewer.siteMediaChangeSelection": "Change Selection",
  "eproViewer.siteMediaExpandTitle": "View Image",
  "eproViewer.siteMediaPDFTitle": "View {pdf}",
  "eproViewer.siteMediaViewUploadedMedia": "View Uploaded Media",
  "eproViewer.siteMediaViewUploadedMediaTitle": "View Media",
  "eproViewer.siteMediaChangeSelectionMessage":
    "Changing this answer will remove the uploaded media. Do you want to permanently remove this media from the question?",
  "eproViewer.textBlockLabel": "Item {itemNumber}: Text content",
  "eproViewer.textEntryEmptyScreenReader":
    "You can enter up to {maxLength} characters in this field",
  "eproViewer.textEntryNotEmptyScreenReader":
    "{currentLength} characters entered out of {maxLength} characters allowed",
  "eproViewer.textEntryQuestionLabel": "Item {itemNumber}: Text Entry question",
  "eproViewer.time": "Time",
  "eproViewer.timeError": "Please enter a time between {min} and {max}.",
  "eproViewer.timeQuestionLabel": "Item {itemNumber}: Time question",
  "eproViewer.visualScaleImageFallback": "Visual Scale",
  "eproViewer.visualScaleQuestionLabel":
    "Item {itemNumber}: Visual Scale question",
  "eproViewer.visualScaleThumbLabelMin": "Minimum: {minimum}. ",
  "eproViewer.visualScaleThumbLabelMax": "Maximum: {maximum}.",
  "eproViewer.websiteIssues": "Website issues",
  "eproViewer.websiteIssuesMessage":
    "Sorry, we are having an issue with our website or servers. Please refresh the page and try again.",
  "eproViewer.youreOffline": "You're offline",
  "eproViewer.youreOnline": "You're online",
  "eproViewer.scaleSlider": "Scale slider",
  "eproViewer.repeatSection.addEntry": "Add Entry",
  "eproViewer.repeatSection.closeEntry": "Close Entry",
  "eproViewer.repeatSection.closeEntryNotCompleted":
    "Your progress is saved. The entry is not complete until all required questions are answered and you select Done.",
  "eproViewer.repeatSection.closeEntryWasCompleted":
    "Your progress is saved. The entry is not complete until all required questions are answered.",
  "eproViewer.repeatSection.delete": "Delete",
  "eproViewer.repeatSection.deleteEntry": "Delete Entry",
  "eproViewer.repeatSection.deleteEntryMessage":
    "All responses for questions in this entry will be deleted. This action cannot be undone.",
  "eproViewer.repeatSection.editEntry": "Edit Entry",
  "eproViewer.transcribeSurvey": "Transcribe Survey",
  "eproViewer.assessmentDate": "Assessment Date",
  "eproViewer.assessmentTime": "Assessment Time (Optional)",
  "eproViewer.assessmentTimezone": "Timezone",
  "eproViewer.transcriptionReason": "Transcription Reason",
  "eproViewer.loginIssues": "Login Issues",
  "eproViewer.deviceBroken": "Device Broken",
  "eproViewer.deviceBattery": "Device Battery",
  "eproViewer.deviceLost": "Device Lost",
  "eproViewer.paperPreferred": "Paper Preferred by Respondent",
  "eproViewer.other": "Other",
  "eproViewer.startTranscription": "Start Transcription",
  "eproViewer.transcribedSurveyBelow": "TRANSCRIBED SURVEY BELOW",
  "eproViewer.pastDateError":
    "You cannot enter a date which is more than 10 years in the past.",
  "eproViewer.futureDateError":
    "You cannot enter a date that is in the future.",
  "eproViewer.futureTimeError":
    "You cannot enter a time that is in the future.",
  "eproViewer.timepoint": "timepoint",
  "eproViewer.dayOfWeek": "dayOfWeek",
  "eproViewer.repeater.minEntryText": "You must add at least 1 entry.",
  "eproViewer.repeater.minEntriesText": "You must add at least {min} entries.",
  "eproViewer.repeater.maxEntryText": "You can only add up to 1 entry.",
  "eproViewer.repeater.maxEntriesText": "You can only add up to {max} entries.",
  "eproViewer.repeater.imageSelected": "Image selected",
  "eproViewer.repeater.incompleteEntryError":
    "Please provide a complete response for all entries.",
  "eproViewer.repeater.viewEntry": "View Entry",
  "eproViewer.repeater.entrySummary": "Entry {number}: {summary}",
  "eproViewer.repeater.noEntries": "No Entries",
  "eproViewer.interactiveImage.selectTheSideOfYourBody":
    "First, select the side of your body:",
  "eproViewer.interactiveImage.pleaseProvideAResponse":
    "Please provide a response.",
  "eproViewer.interactiveImage.frontOfBody": "Front of Body",
  "eproViewer.interactiveImage.backOfBody": "Back of Body",
  "eproViewer.interactiveImage.right": "Right",
  "eproViewer.interactiveImage.left": "Left",
  "eproViewer.interactiveImage.selectRegion": "Select Region",
  "eproViewer.interactiveImage.chooseADifferentSide": "Choose a different side",
  "eproViewer.interactiveImage.done": "Done",
  "eproViewer.interactiveImage.changeSelection": "Change Selection",
  "eproViewer.interactiveImage.makeSelection": "Make Selection",
  "eproViewer.interactiveImage.selectJoints": "Select Joints",
  "eproViewer.freeDraw.clearDrawing": "Clear Drawing",
  "eproViewer.freeDraw.clearDrawingMessage":
    "Once cleared, this drawing cannot be restored. Are you sure you want to continue?",
  "eproViewer.freeDraw.continue": "Continue",
  "eproViewer.freeDraw.exitWithoutSaving": "Exit Without Saving",
  "eproViewer.freeDraw.exitWithoutSavingMessage":
    "Unsaved changes to your drawing will be lost.",
  "eproViewer.freeDraw.drawResponse": "Draw Response",
  "eproViewer.freeDraw.canvasSizeWarning":
    "The current drawing is larger than the canvas. Only what is visible in the canvas will be saved.",
  "eproViewer.freeDraw.draw": "Draw",
  "eproViewer.freeDraw.erase": "Erase",
  "eproViewer.freeDraw.undo": "Undo",
  "eproViewer.freeDraw.clear": "Clear",
  "eproViewer.freeDraw.responseImageAltText": "freeDraw-response-image",
  "eproViewer.freeDraw.editResponse": "Edit Response",
  "eproViewer.freeDraw.canvasControls": "Canvas Controls",
  "eproViewer.overlay": "Overlay",
  "eproViewer.partMissedHeading": "Missed",
  "eproViewer.partMissedBody":
    "This part of the survey was missed and cannot be completed.",
  "eproViewer.partIlbHeading": "Intentionally Left Blank",
  "eproViewer.partIlbBody":
    "This part of the survey was intentionally left blank by the study team.",
  "eproViewer.partMissedOrIlbHeading":
    "Survey Part Missed or Intentionally Left Blank",
  "eproViewer.partRemovedHeading": "Removed",
  "eproViewer.partRemovedBody":
    "This part of the survey was removed by the study team.",
  "eproViewer.partQuarantinedHeading": "Cannot Be Displayed",
  "eproViewer.partNotCompletedHeading": "Not Completed",
  "eproViewer.partNotCompletedBody":
    "This part of the survey is scheduled or available but has not been completed.",
  "eproViewer.multipleStatuses": "Multiple Statuses",
  "eproViewer.updatedByMultipleUsers": "Updated by Multiple Users",
  "sites.eproViewer.freeDraw.noDataChange": "Data Change Not Allowed",
  "sites.eproViewer.freeDraw.noDataChangeMessage":
    "Data Change cannot be performed on this question.",
  "sites.eproViewer.freeDraw.noDataChangeMessagePleaseAcknowledge":
    "This question cannot be answered during Data Change. Please acknowledge below to continue.",
  "sites.eproViewer.freeDraw.noDataChangeAcknowledgement":
    "I acknowledge that this question cannot be answered during Data Change.",
  "sites.eproViewer.freeDraw.noTranscription": "Question Cannot Be Transcribed",
  "sites.eproViewer.freeDraw.noTranscriptionMessage":
    "This type of question cannot be transcribed. Please acknowledge below to continue.",
  "sites.eproViewer.freeDraw.noTranscriptionAcknowledgement":
    "I acknowledge that this question cannot be transcribed.",
  "sites.eproViewer.freeDraw.pleaseAcknowledgeToContinue":
    "Please acknowledge to continue.",
  "sites.andSponsors.dataChange.skipped": "SKIPPED",
  "sites.andSponsors.dataChange.previous": "Previous",
  "sites.andSponsors.dataChange.updated": "Updated",
  "sites.andSponsors.dataChange.freeDrawHidden":
    "The Free Draw block was hidden by a condition during data change.",
  "sites.andSponsors.dataChange.freeDrawDisplayed":
    "The Free Draw block was displayed by a condition during data change.",
  "sites.andSponsors.dataChange.conditionalAvailabilityNoResponseIncluded":
    "Conditional availability no response included in survey data",
  "sites.andSponsors.dataChange.conditionalAvailabilityNoResponseCollected":
    "Conditional availability no response collected",
  "sites.andSponsors.dataChange.frontOfBody": "Front of Body",
  "sites.andSponsors.dataChange.backOfBody": "Back of Body",
}
